import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import Keyboard from '../gameItems/Keyboard';
import NavBar from '../gameItems/NavBar';
import Popup from '../gameItems/Popup';
import Rocket from '../gameItems/Rocket';

export default class Game extends Phaser.Scene
{
    static get KEY() { return 'Game'; }

    preload()
    {
        // preload your assets here, if needed
        this.anims.create({ key: 'burn', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 15, prefix: 'flames_v2_' }), frameRate: 64, repeat: -1 });
        this.anims.create({ key: gameData.FIREWORKS[0], frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 10, prefix: 'firework_' }), frameRate: 24});
        this.anims.create({ key: gameData.FIREWORKS[1], frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 10, prefix: 'fireworkOrange_' }), frameRate: 24});
        this.anims.create({ key: gameData.FIREWORKS[2], frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 10, prefix: 'fireworkBlue_' }), frameRate: 24});
        this.anims.create({ key: gameData.GLITTER[0], frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 3, prefix: 'fireworkGlitterGreen_' }), frameRate: 24, repeat: -1 });
        this.anims.create({ key: gameData.GLITTER[1], frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 3, prefix: 'fireworkGlitter_' }), frameRate: 24, repeat: -1 });
        this.anims.create({ key: gameData.GLITTER[2], frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 3, prefix: 'fireworkGlitterBlue_' }), frameRate: 24, repeat: -1 });
    }

    create()
    {
        console.log("GAME HAS LOADED");
        gameData.GAME_STATE = "game";
        gameData.WORDS_MISSED = 0;

        this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

        this.bgCont = this.add.container(this.mid.x, this.mid.y);

        const key = "bgFull";
        this.maxRockets = gameData.DESKTOP ? 10 : 7;
        gameData.ROCKETPOS_ARR = gameData.DESKTOP ? [65, 165, 265, 365, 465, 565, 665, 765, 865, 965] : [65, 165, 265, 365, 465, 565, 665];

        this.bg = ABCyaPhaser.Images.addImage(0, 0, null, this.bgCont, key);
        this.bg2 = ABCyaPhaser.Images.addImage(0, -this.bg.height + 2, null, this.bgCont, key);

        Phaser.Utils.Array.Shuffle(gameData.ROCKETPOS_ARR);
        Phaser.Utils.Array.Shuffle(gameData.WORD_BANK);

        this.toggleJingle();
        this.startGame();
    }

    startGame(){
        //turn the windows on
        this.skyTweenIn();
        this.createNav();
        this.createRockets(true);
        this.createKeyboard();
    };

    skyTweenIn(){
        //console.log("starting intro");
        this.bgCont.y = this.mid.y;

        this.bgTween = ABCyaPhaser.Tweens.addTween(this.bgCont, 40000, {y:this.bg.height + this.mid.y}, Phaser.Math.Easing.Linear, ()=>{
            this.skyTweenIn();
        });
    };

    createNav(){
        this.navBar = new NavBar(this);
    };

    toggleJingle(){
        // if(this.lvlSound){
        //     this.lvlSound.stop();
        //     this.lvlSound = null;
        // } else {
        //     this.lvlSound = createjs.Sound.play("jingle", {interrupt: createjs.Sound.INTERRUPT_NONE, loop:-1});
        //     this.lvlSound.volume = .1;
        // }

        ABCyaPhaser.Audio.playOneShot("Jingle_Typing_Rock", this, .3, true);
    };

    createRockets(init = false){
        if(gameData.ROCKET_ARR.length < this.maxRockets){
            let rocket = new Rocket(this);
            this.children.moveTo(rocket, 1);

            //set rocket's x to the first position in the pos array then remove it from the array
            //when the rocket is destroyed, it's X position is pushed back into the array then shuffled
            rocket.x = gameData.ROCKETPOS_ARR[0];
            gameData.ROCKETPOS_ARR.shift();

            if(!gameData.DESKTOP){
                rocket.y = this.mid.y*2;

                this.time.delayedCall(1000, ()=>{
                    rocket.moveRocket("fly", init);
                });
            } else {
                rocket.y = this.mid.y*2 + rocket.body.height;

                rocket.moveRocket("fly", init);
            }

            let tempWord = gameData.WORD_BANK[0];
            while(tempWord == null || tempWord == "" || tempWord == undefined){
                console.log("OH NO UNDEFINED!");
                Phaser.Utils.Array.Shuffle(gameData.WORD_BANK);
                tempWord = gameData.WORD_BANK[0];
            }

            rocket.setWord(tempWord);
            gameData.WORD_BANK.shift();

            gameData.ROCKET_ARR.push(rocket);
        }
    };

    createKeyboard(){
        //    console.log("adding keyboard");
        this.keyBoard = new Keyboard(this, this.mid.x, this.mid.y*2);
        // this.keyBoard.isActive = false;
    
        // ABCyaPhaser.Tweens.addTween(this.keyBoard, 1000, {y:this.mid.y*2 - 140}, Phaser.Math.Easing.Quadratic.Out, ()=>{this.keyBoard.isActive = true;});
    };

    explode(obj){
        const randScale = Phaser.Math.FloatBetween(1.4, 2);
        const randFirework = Phaser.Math.Between(0, 2);
        const cSound = Phaser.Math.Between(0,1);
        ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[cSound], this);

        let fw = this.add.sprite(obj.x, obj.y - 50).play(gameData.FIREWORKS[randFirework]).setScale(randScale);
        let fwG = this.add.sprite(fw.x, fw.y).play(gameData.GLITTER[randFirework]).setScale(0);

        fw.once('animationcomplete', ()=>{ this.destroyFirework(fw); });
        
        ABCyaPhaser.Tweens.addTween(fwG, 300, {alpha:1, scale:randScale + .2}, Phaser.Math.Easing.Quadratic.Out, ()=>{this.launchGlitter(fwG);});
    };

    launchGlitter(obj){
        let randTime = Phaser.Math.Between(1000, 2000);
        ABCyaPhaser.Tweens.addTween(obj, randTime, {y:obj.y + 100, alpha:0, scaleX:obj.scaleX + .1, scaleY:obj.scaleY + .1}, Phaser.Math.Easing.Quadratic.Out, ()=>{this.destroyGlitter(obj);});
    };

    destroyGlitter(obj){
        obj.destroy();
        obj = null;
    };

    destroyRocket(obj){
        obj.destroy();
        obj = null;
    };

    destroyFirework(obj){
        obj.destroy();
        obj = null;
    };

    showPopup(type){
        if(this.bgTween){
            this.bgTween.pause();
        }

        gameData.GAME_PAUSED = true;

        if(!this.popup){
            this.popup = new Popup(this, type);
        }

        if(this.navBar){
            this.navBar.pauseBtn.setEnabled(false);
        }

        if(gameData.ROCKET_ARR.length > 0){
            for(let b = 0; b < gameData.ROCKET_ARR.length; b++){
                gameData.ROCKET_ARR[b].toggleMovement(false);
            }
        }

        if(this.keyBoard){
            this.keyBoard.isActive = false;
        }
    };

    destroyPopup(type){
        this.popup.btnCont.destroy();
        this.popup.destroy();
        this.popup = null;
        gameData.GAME_PAUSED = false;

        if(type == "resume"){
            this.navBar.pauseBtn.setEnabled(true);
            this.navBar.setClock("resume");
        }

        if(this.keyBoard){
            this.keyBoard.isActive = true;
        }

        if(this.bgTween){
            this.bgTween.resume();
        }

        if(gameData.ROCKET_ARR.length > 0){
            for(let b = 0; b < gameData.ROCKET_ARR.length; b++){
                gameData.ROCKET_ARR[b].toggleMovement(true);
            }
        }
    };

    cleanUp(){
        if(gameData.ROCKET_ARR.length < 10)
            for(let b = 0; b < gameData.ROCKET_ARR.length; b++){
                gameData.ROCKET_ARR[b].destroyRocket();
            }

        this.tweens.killAll();
        this.sound.stopAll();

        gameData.SCORE = 0;
        gameData.SPEED = 10000;
        gameData.ROCKET_ARR = [];
        gameData.WORDS_MADE = 0;
        gameData.WORDS_MISSED = 0;
        gameData.GAME_PAUSED = false;
        gameData.GAME_DONE = false;
        gameData.WORD_BANK = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
            "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

        this.popup?.destroy();
        this.popup = null;

        this.navBar.removeAll();
        this.navBar.destroy();
        this.navBar = null;

        this.scene.start("Intro");
    };
}